import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IStyleProps {
  index?: number;
  active?: boolean;
  marginTop?: string;
  marginLeft?: string;
  icon?: boolean;
  right?: boolean;
}

export const Root = styled.div`
  position: absolute;
  z-index: 10000;
  display: inline-flex;
  margin-top: ${(props: IStyleProps) => props.marginTop ? props.marginTop : '200px'};
  margin-left: ${(props: IStyleProps) => props.marginLeft ? props.marginLeft : '400px'};
  font-size: 12px;
  font-weight: normal;
  width: 158px;
  height: auto;
`;

export const Contenedor = styled.div`
  font-size: 12px;
  font-weight: normal;
  width: 158px;
  height: auto;
  background-color: ${C.WHITE};
  border-radius: 3px;
  box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.25);
  position: absolute;
  z-index: 10000;
  margin-top: ${(props: IStyleProps) => props.marginTop ? props.marginTop : '200px'};
  margin-left: ${(props: IStyleProps) => props.marginLeft ? props.marginLeft : '400px'};
`;

export const Label = styled.div`
  display: block;
  flex-grow: 0;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  padding: 13px 14px;
  color: ${C.BLACK};
`;

export const Category = styled.div`
  width: ${(props: IStyleProps) => props.right ? '130px' : '121px'};
  background-color: ${(props: IStyleProps) => props.active ? 'rgba(196, 196, 196, 0.2)' : 'transparent'} ;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: ${(props: IStyleProps) => props.right ? '13px 14px' : !props.icon ? '13px 14px' : '13px 7px 13px 30px'};
  &:hover {
    background-color: rgba(196, 196, 196, 0.2);
  }
  position: relative;
`;

export const Text = styled.span`
  color: ${C.DARK_GRAY};
  width: ${(props: IStyleProps) => props.icon ? '120px': "100%"};
`;

export const Icon = styled.div`
  position: absolute;
  right: ${(props: IStyleProps) => props.right ? '6.7px' : ''};
  left: ${(props: IStyleProps) => !props.right ? '6.7px' : ''};
`;

export const Fields = styled.div`
  width: 100%;
  height: fit-content;
  display: inline-block;
  background-color: ${C.WHITE};
  border-radius: 3px;
  box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.25);
`;